var _rect, _circle, _circle2, _circle3, _path, _path2, _path3, _rect2, _rect3, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInflammation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    rx: 16,
    fill: "#fff1f2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 125,
    r: 55,
    fill: "#ffe4e6",
    stroke: "#f43f5e",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 125,
    r: 35,
    fill: "#fecdd3",
    opacity: 0.45
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 125,
    r: 18,
    fill: "#f43f5e",
    opacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148 78 C153 68 158 73 163 63",
    stroke: "#f43f5e",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200 62 C205 52 210 57 215 47",
    stroke: "#f43f5e",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M245 78 C250 68 255 73 260 63",
    stroke: "#f43f5e",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.3,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 200,
    width: 48,
    height: 20,
    rx: 10,
    fill: "white",
    stroke: "#f43f5e",
    strokeWidth: 1.5,
    opacity: 0.45
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 200,
    width: 24,
    height: 20,
    rx: 10,
    fill: "#f43f5e",
    opacity: 0.12
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 262,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#9f1239"
  }, "Iltihaplanma")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInflammation);
export default __webpack_public_path__ + "static/media/inflammation.2fbff7cad15cb73e428ca77037809b99.svg";
export { ForwardRef as ReactComponent };